export const topNavMenuOperations = [
    { name: 'Line Maintenance', redirect: '/org/operations/line_maintenance/work_order', section: '/line_maintenance/work_order' },
    { name: 'Workshop', redirect: '/org/operations/workshop/maintenance', section: '/operations/workshop' },
    { name: 'Base', redirect: '/org/operations/base/in_progress', section: '/operations/base' },
    { name: 'Flying Spanner', redirect: 'org/operations/flying_spanner/journey', section: '/operations/flying_spanner' }, { name: 'Shift Plan', redirect: 'org/operations/shift_plan', section: '/operations/shift_plan' },
    { name: 'Job Clockings', redirect: '/org/operations/job_clockings/live', section: '/operations/job_clockings' },
    { name: 'Compliance', redirect: '/org/operations/compliance/station_checks', section: '/operations/compliance' },
    { name: 'Handover', redirect: '/org/operations/handover/history', section: '/operations/handover' },
];

export const topNavMenuPlanning = [
    { name: 'Line', redirect: '/org/planning/line/planned_work_order', section: '/planning/line' },
    { name: 'Workshop', redirect: '/org/planning/workshop/maintenance', section: '/planning/workshop' },
    { name: 'Base', redirect: '/org/planning/base/workpacks', section: '/planning/base' },
    { name: 'Shifts', redirect: '/org/planning/shifts/shift_plane', section: '/planning/shifts' },
    { name: 'Resource', redirect: '/org/planning/resource/shift_patterns', section: '/planning/resource' },
];

export const topNavMenuDashboards = [
    { name: "Line Maintenance", redirect: "/org/dashboard/line_maintenance/performance", section: "/dashboard/line_maintenance" },
    { name: "Workshop", redirect: "/org/dashboard/workshop/maintenance", section: "/dashboard/workshop" },
    { name: "User Compliance", redirect: "/org/dashboard/user_compliance", section: "/dashboard/user_compliance", },
    { name: "Station Compliance", redirect: "/org/dashboard/station/compliance", section: "/dashboard/station" },
    { name: "Stores", redirect: "/org/dashboard/stores/oil_accuracy", section: "/dashboard/stores" },
];

export const topNavMenuStores = [
    { name: 'Parts', redirect: '/org/stores/parts', section: '/stores/parts' },
    { name: 'Tooling', redirect: '/org/stores/tooling/in_stock', section: '/stores/tooling' },
    { name: 'Form 1 / 8130', redirect: '/org/stores/form1', section: '/stores/form1' },
    { name: 'Expendables', redirect: '/org/stores/expandables/items', section: '/stores/expandables' },
];

export const topNavMenuProcurement = [
    { name: 'Parts', redirect: '/org/procurement/parts/request', section: '/procurement/parts' },
    { name: 'Services', redirect: '/org/procurement/services', section: '/procurement/services' },
    { name: 'Equipment', redirect: '/org/procurement/equipment/requests', section: '/procurement/equipment' },
    { name: 'Kits', redirect: '/org/procurement/kits/kit', section: '/procurement/kits' },
];

export const topNavMenuCompliance = [
    { name: 'User compliance', redirect: '/org/compliance/user_compliance', section: '/compliance/user_compliance' },
    { name: 'Procedures', redirect: '/org/compliance/procedures', section: '/compliance/procedures' },
    { name: 'Read & Signs', redirect: '/org/compliance/read_and_signs', section: '/compliance/read_and_signs' },
    { name: 'Approvals', redirect: '/org/compliance/approvals/approval_types', section: '/compliance/approvals' },
    { name: 'Supplier', redirect: '/org/compliance/suppliers', section: '/compliance/suppliers' },
    { name: 'Admin', redirect: '/org/compliance/admin/training', section: '/compliance/admin' },
];

export const topNavMenuAccounts = [
    { name: 'Line Maintenance', redirect: '/org/accounts/line_maintenance/lineworkorder', section: '/accounts/line_maintenance' },
    { name: "Workshop", redirect: '/org/accounts/workshop/maintenance', section: '/accounts/workshop' },
    { name: "Base", redirect: '/org/accounts/base/workpacks', section: '/accounts/base' },
    { name: "Flying Spanner", redirect: '/org/accounts/flying_spanner/journey', section: '/accounts/flying_spanner' },
    { name: 'ADHOC Invoicing', redirect: '/org/accounts/adhoc_invoicing', section: '/accounts/adhoc_invoicing' },
    { name: "Part Sales", redirect: '/org/accounts/part_sales/sales', section: '/accounts/part_sales' },
    { name: 'Admin', redirect: '/org/accounts/admin/currencies', section: '/accounts/admin' },
    // { name: 'Kits', redirect: '/org/accounts/kits', section: '/accounts/kits' },
]

export const topNavMenuAdmin = [
    { name: 'Bases', redirect: '/org/admin/bases', section: '/admin/bases' },
    { name: 'Users', redirect: '/org/admin/users/user_lists', section: '/admin/users' },
    { name: 'Vehicles', redirect: '/org/admin/vehicles', section: '/admin/vehicles' },
    { name: 'Stores', redirect: '/org/admin/stores/suppliers', section: '/admin/stores' },
    { name: 'Base Maint', redirect: '/org/admin/base_maint', section: '/admin/base_maint' },
    { name: 'Usage Report', redirect: '/org/admin/usage_report', section: '/admin/usage_report' },
];

export const topNavMenuReports = [
    { name: 'Reports', redirect: '/org/reports/sub_reports/favourites', section: '/reports/sub_reports' },
    { name: 'Admin', redirect: '/org/reports/admin/setup', section: '/reports/admin' },

];
export const topNavMenuSMS = [
    { name: 'My SMS', redirect: '/org/sms/mysms/my_report', section: '/sms/mysms' },
    { name: 'Audits', redirect: '/org/sms/audits/schedule', section: '/sms/audits' },
    { name: 'Inputs', redirect: '/org/sms/inputs/overview', section: '/sms/inputs' },
    { name: 'Tasks', redirect: '/org/sms/tasks/overview', section: '/sms/tasks' },
    { name: 'Meetings', redirect: '/org/sms/meetings/', section: '/sms/meetings' },
    { name: 'Risk', redirect: '/org/sms/risks/', section: '/sms/risks' },
    { name: 'Admin', redirect: '/org/sms/admin/bowtie_item', section: '/sms/admin' },
];
export const topNavMenuCommercial = [

    {

        name: 'Line',
        redirect: '/org/commercial/line/customer',
        section: '/commercial/line'
    },

    {

        name: 'Workshop',
        redirect: '/org/commercial/workshop/customer',
        section: '/commercial/workshop'
    },
    {

        name: "Base",
        redirect: '/org/commercial/base/customer',
        section: '/commercial/base'
    },
    {

        name: 'Parts',
        redirect: '/org/commercial/parts/sales',
        section: '/commercial/parts'
    },
    {

        name: 'Admin',
        redirect: '/org/commercial/admin/terms&condition',
        section: 'commercial/admin'
    },

]